<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
.van-password-input__item {
  border: 2px solid #409eff;
  border-radius: 10px;
}
.van-step__circle {
  width: 16px;
  height: 16px;
}
.van-step__line {
  transform: translate(-50%, 0);
}
.van-checkbox__icon {
  align-self: flex-start;
}
.van-checkbox__label {
  line-height: normal;
}
.van-icon {
  font-size: 0.38rem;
}

.van-toast {
  border-radius: 0.2rem;
}
.van-toast__text {
  word-break: keep-all !important;
  font-size: 0.28rem;
  line-height: 1.3;
  padding: 0.08rem 0.07rem;
}
.van-field {
  // line-height: 0.38rem !important;
  padding: 0.16rem 0.26rem;
}
.van-field__body {
  font-size: 0.26rem;
}

.van-toast--loading {
  padding: 0.3rem;
  min-width: 1rem !important;
  height: 1rem !important;
}
.van-loading__spinner {
  width: 0.5rem !important;
  height: 0.5rem !important;
}
.van-popup--bottom.van-popup--round {
  border-radius: 0.3rem 0.3rem 0 0;
}

.flot_view {
  position: fixed;
  width: 100%;
  // bottom: constant(safe-area-inset-bottom); /* iOS < 11.2 */;
  // bottom: env(safe-area-inset-bottom); /* iOS >= 11.2 + 安卓现代浏览器 */
  bottom: 0;
  left: 0;
  background-color: white;
  padding: 0.3rem 0.42rem;
  box-sizing: border-box;
  /* 模糊20px，扩展5px → 阴影范围更大、更明显 */
  box-shadow: 0 0 20px 5px rgba(0, 0, 0, 0.15);
}
</style>
